import { parseRequestError } from '@/app/common/utilities'
import axiosInstance from '@/libs/axios_config'
import {
  MarketplaceItemListSchema,
  MarketplaceItemSchema,
} from './marketplace.schema'

const MarketplaceEndpoints = {
  getItems: '/scholar/marketplace/items',
} as const

export const GETMarketplaceItems = async (
  programId?: number,
  business_type?: string,
  search?: string,
  provider_id?: number,
  affiliation_id?: number,
  acceptingNewClients?: number,
  perPage: number = 10,
  page: number = 1
) => {
  try {
    const response = await axiosInstance.get(MarketplaceEndpoints.getItems, {
      params: {
        program_id: programId,
        ...(business_type && { business_type }),
        ...(search && { search }),
        ...(provider_id && { provider_id }),
        ...(affiliation_id && { affiliation_id }),
        accepting_new_clients: acceptingNewClients,
        per_page: perPage,
        page,
      },
    })

    return MarketplaceItemListSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const GETMarketplaceItemDetail = async (
  itemId: number,
  thirdPartyItemId?: number
) => {
  try {
    if (itemId == null) {
      return Promise.reject(new Error('Invalid request'))
    }
    const response = await axiosInstance.get(
      `/scholar/marketplace/items/${itemId}`,
      {
        params: thirdPartyItemId
          ? { third_party_item_id: thirdPartyItemId }
          : undefined,
      }
    )
    return MarketplaceItemSchema.parse(response.data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}

type CartItem = {
  quantity: number
  id: number
  provider_third_party_item_id?: number | null
}

type Purse = {
  amount: number
  id: number
}

export interface CheckoutArgs {
  program_id: number
  items: CartItem[]
  purses: Purse[]
}

export const POSTCheckout = async (args: CheckoutArgs) => {
  return await axiosInstance.post('/scholar/marketplace/checkout', args)
}
